import styled from '@emotion/styled';

import { breakpoints } from '@datacamp/waffles-tokens';

export const Container = styled.nav`
  align-items: center;
  display: flex;
  justify-content: space-between;
  margin: 0 auto;
  max-width: 1170px;
  padding: 12px 16px 0;
  position: relative;

  @media screen and (min-width: ${breakpoints.sm}) {
    padding: 12px 32px 0;
  }

  @media screen and (min-width: ${breakpoints.lg}) {
    padding: 12px 16px 0;
  }
`;

export const Logo = styled.a`
  border: 0;

  img {
    display: block;
  }
`;
